/**
 * Below are the colors that are used in the app. The colors are defined in the light and dark mode.
 * There are many other ways to style your app. For example, [Nativewind](https://www.nativewind.dev/), [Tamagui](https://tamagui.dev/), [unistyles](https://reactnativeunistyles.vercel.app), etc.
 */

const linkColorLight = "#0a7ea4";
const linkColorDark = "#0a7ea4";

const tintColorLight = linkColorLight;
const tintColorDark = linkColorDark;

export const Colors = {
  light: {
    primary: "#204169",
    primaryDark: "#1a3556", // A darker shade of #204169
    onPrimary: "#FFFFFF",
    secondary: "#FF9500",
    onSecondary: "#FFFFFF",

    text: "#11181C",
    background: "#fff",
    surface: "#FFFFFF",
    textSecondary: "#6C757D",
    stripes: "rgb(225, 225, 225)",

    tint: tintColorLight,
    icon: "#687076",
    tabIconDefault: "#687076",
    tabIconSelected: tintColorLight,

    // UI specific colors
    tabBarBackground: "#1e3a8a",
    tabIconActive: "#FFFFFF",
    tabIconInactive: "rgba(255,255,255,0.6)",
    border: "#E2E2E2",
    statusBar: "dark-content",
    success: "#34C759",
    error: "#FF3B30",
    warning: "#FFCC00",
    notificationBackground: "#e6ecf8",
  },
  dark: {
    primary: "#204169", // Updated primary for dark theme
    onPrimary: "#FFFFFF",

    text: "#ECEDEE",
    textSecondary: "#6C757D",
    stripes: "#C9CCD3",

    background: "#151718",
    tint: tintColorDark,
    icon: "#9BA1A6",
    tabIconDefault: "#9BA1A6",
    tabIconSelected: tintColorDark,
    tabBarBackground: "#1e3a8a",
    tabIconActive: "#FFFFFF",
    tabIconInactive: "rgba(255,255,255,0.6)",
    notificationBackground: "#e6ecf8",
  },
};
